const debounce = function (fn, delay) {
    let timer = null;
    return function () { // do not use arrow function here
        let ctx = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(ctx, args), delay);
    };
};


export const Utils = {
    debounce: debounce
};


// WEBPACK FOOTER //
// ./uPortal/Content/js/Extensions/utils.js